import React from 'react';
import { Redirect, Route } from 'react-router';
import { getAccessToken } from '../../utils/storage';
import { PropTypes } from 'prop-types';

const GuestRoute = ({ component: Component, ...rest }) => {
    const isAuth = !!getAccessToken();
    return (
        <>
            <Route
                {...rest}
                render={(props) => (!isAuth ? <Component {...props} /> : <Redirect to="/" />)}
            />
        </>
    );
};
GuestRoute.propTypes = {
    component: PropTypes.func
};

export default GuestRoute;
